/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Rounds_Seating_Moving_FinalsInputs */



/**
* | output |
* | --- |
* | "Moving {name} — tap another seat to swap" |
*
* @param {Rounds_Seating_Moving_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_moving_finals = /** @type {((inputs: Rounds_Seating_Moving_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_Moving_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Déplacement de ${i?.name} — appuyez sur un autre placement pour échanger`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Moviendo a ${i?.name} — pulse otro asiento para intercambiar`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Movendo ${i?.name} — toque em outro assento para trocar`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Spostamento di ${i?.name} — tocca un altro posto per scambiare`)
	return /** @type {LocalizedString} */ (`Moving ${i?.name} — tap another seat to swap`)
});